import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { cn } from '../ui/utils';
import { Building2, MapPin, Clock, Fingerprint } from 'lucide-react';

interface WellInfoCardProps {
    well: any;
    isDarkMode: boolean;
}

export function WellInfoCard({ well, isDarkMode }: WellInfoCardProps) {
    const items = [
        { label: 'Company', value: well.company || 'N/A', icon: Building2 },
        { label: 'Location', value: well.location || 'N/A', icon: MapPin },
        {
            label: 'Last Checked',
            value: well.lastEntry ? new Date(well.lastEntry).toLocaleDateString() : 'Never',
            icon: Clock
        },
        { label: 'Well ID', value: well.id, icon: Fingerprint, mono: true },
    ];

    return (
        <Card className={cn(isDarkMode ? "bg-slate-900 border-slate-800" : "bg-white border-slate-200 shadow-sm")}>
            <CardHeader className="pb-3">
                <CardTitle className={cn("text-base font-semibold", isDarkMode ? "text-white" : "text-slate-900")}>
                    Well Information
                </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
                {items.map((item) => (
                    <div key={item.label} className="flex items-center justify-between group">
                        <div className="flex items-center gap-2.5 text-sm text-muted-foreground group-hover:text-foreground transition-colors">
                            <div className={cn("p-1.5 rounded-md", isDarkMode ? "bg-slate-800 text-slate-400" : "bg-slate-100 text-slate-500")}>
                                <item.icon className="w-4 h-4" />
                            </div>
                            <span>{item.label}</span>
                        </div>
                        <span className={cn(
                            "text-sm font-medium text-right",
                            item.mono ? "font-mono text-xs" : "",
                            isDarkMode ? "text-slate-200" : "text-slate-900"
                        )}>
                            {item.value}
                        </span>
                    </div>
                ))}
                {/* Location Details Text */}
                {well.locationDetails && (
                    <div className={cn(
                        "mt-4 p-3 rounded-lg text-sm leading-relaxed border",
                        isDarkMode
                            ? "bg-slate-950/50 border-slate-800 text-slate-400"
                            : "bg-slate-50 border-slate-100 text-slate-600"
                    )}>
                        {well.locationDetails}
                    </div>
                )}
            </CardContent>
        </Card>
    );
}
